module.exports = __webpack_public_path__ + "img/imagen2.40c7ab2b.png";